// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"card-wrapper_1GyrX"};